import { memo } from 'react';
import ImageComponent from '../components/image';

const Image = memo(ImageComponent);

export default Image;
